export const LOADING = "Advert/LOADING"
export const CLEAR_ADVERT = "Advert/CLEAR_ADVERT"

export const clearAdvert = id => ({
    type: CLEAR_ADVERT,
    payload: id
})